"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilesApi = void 0;
var next_api_swr_1 = require("@newfront-insurance/next-api-swr");
var next_notifications_1 = require("@newfront-insurance/next-notifications");
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var routes_1 = require("../bff/routes");
function useFilesApi() {
    var notifications = (0, next_notifications_1.useNotifications)();
    var fetcher = (0, next_api_swr_1.useNextApiFetcher)();
    return (0, react_1.useMemo)(function () {
        // TODO: Make following base path configurable. https://linear.app/newfront/issue/BUGS-567/files-ui-create-a-filesuicontextprovider-and-remove-hardcoded-base
        var apiRoutes = (0, routes_1.createApiRoutes)('/api/files');
        return {
            archive: archiveFn(fetcher, apiRoutes),
            unarchive: unarchiveFn(fetcher, apiRoutes),
            getRawContentsUrl: getRawContentsUrlFn(fetcher, notifications, apiRoutes),
            getAssociations: getAssociationsFn(fetcher, notifications, apiRoutes),
            getSignedUrl: getSignedUrlFn(fetcher, notifications, apiRoutes),
            commit: getCommitFn(fetcher, apiRoutes),
            uploadContents: getUploadFn(axios_1.default),
            update: getUpdateFn(fetcher, apiRoutes),
            getFiles: getFilesFn(fetcher, notifications, apiRoutes),
        };
    }, [fetcher, notifications]);
}
exports.useFilesApi = useFilesApi;
function archiveFn(fetcher, apiRoutes) {
    var _this = this;
    return function (id) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetcher.request({
                        url: apiRoutes.archiveFile({ id: id }),
                        method: 'POST',
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
function unarchiveFn(fetcher, apiRoutes) {
    var _this = this;
    return function (id) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetcher.request({
                        url: apiRoutes.unarchiveFile({ id: id }),
                        method: 'POST',
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
function getRawContentsUrlFn(fetcher, notifications, apiRoutes) {
    var _this = this;
    return function (query) { return __awaiter(_this, void 0, void 0, function () {
        var _a, data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetcher.request({
                        url: apiRoutes.getFileContents(query),
                        method: 'GET',
                    })];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (error || !data) {
                        notifications.addById(query.id, { title: 'There was a problem retrieving the file url', type: 'error' });
                        throw error;
                    }
                    return [2 /*return*/, data.rawUrl];
            }
        });
    }); };
}
function getAssociationsFn(fetcher, notifications, apiRoutes) {
    var _this = this;
    return function (references) { return __awaiter(_this, void 0, void 0, function () {
        var _a, data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetcher.request({
                        url: apiRoutes.getAssociations(),
                        method: 'POST',
                        body: references,
                    })];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (error || !data) {
                        notifications.add({ title: 'There was a problem retrieving associations', type: 'error' });
                        throw error;
                    }
                    return [2 /*return*/, data];
            }
        });
    }); };
}
function getSignedUrlFn(fetcher, notifications, apiRoutes) {
    var _this = this;
    return function (body) { return __awaiter(_this, void 0, void 0, function () {
        var _a, data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetcher.request({
                        url: apiRoutes.getSignedURL(),
                        method: 'POST',
                        body: body,
                    })];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (error || !data) {
                        notifications.add({ title: 'There was a problem retrieving the upload url', type: 'error' });
                        throw error;
                    }
                    return [2 /*return*/, data];
            }
        });
    }); };
}
function getCommitFn(fetcher, apiRoutes) {
    var _this = this;
    return function (id) { return __awaiter(_this, void 0, void 0, function () {
        var _a, data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetcher.request({
                        url: apiRoutes.commitFileUpload(),
                        method: 'POST',
                        body: {
                            id: id,
                        },
                    })];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (error || !data) {
                        throw error;
                    }
                    return [2 /*return*/, data];
            }
        });
    }); };
}
function getUploadFn(axiosClient) {
    var _this = this;
    return function (uploadUrl, file) { return __awaiter(_this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = {
                        headers: {
                            'Content-Type': file.type,
                        },
                        withCredentials: false,
                    };
                    return [4 /*yield*/, axiosClient.put(uploadUrl, file, options)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
function getUpdateFn(fetcher, apiRoutes) {
    var _this = this;
    return function (body) { return __awaiter(_this, void 0, void 0, function () {
        var _a, data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetcher.request({
                        url: apiRoutes.updateFile({ id: body.id }),
                        method: 'PUT',
                        body: body,
                    })];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (error || !data) {
                        throw error;
                    }
                    return [2 /*return*/, data];
            }
        });
    }); };
}
function getFilesFn(fetcher, notifications, apiRoutes) {
    var _this = this;
    return function (reference) { return __awaiter(_this, void 0, void 0, function () {
        var _a, data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetcher.request({
                        url: apiRoutes.getFiles(reference),
                        method: 'GET',
                    })];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (error || !data) {
                        notifications.add({ title: 'There was a problem retrieving files', type: 'error' });
                        throw error;
                    }
                    return [2 /*return*/, data];
            }
        });
    }); };
}
